/**
 * Client for the general (PMS) repricing Strategies API.
 *
 * Replaces the calls to `BACKEND_APIS.DS_REPRICING`
 * (`/api/pricing-tool/ds/*`), which write the legacy `DS_REPRICING`
 * table with `uid` tenancy — the AutoEurope repricing. This screen now
 * writes the canonical `repricing_strategy*` tables with `company`
 * tenancy (CU-869f043c1). The legacy blueprint keeps its own rows; it
 * simply has no caller from here any more.
 */
import { BACKEND_APIS } from '@constants/routes'
import { makeClient, resource } from 'Pages/DsRepricing/@services/http'

export { ApiError } from 'Pages/DsRepricing/@services/http'

export const API = BACKEND_APIS.GENERAL_REPRICING_STRATEGIES_API

const http = makeClient(API)
const strategies = resource(http, '')

export const strategiesApi = {
	list:   strategies.list,
	get:    strategies.get,
	create: strategies.create,
	update: strategies.update,
	remove: strategies.remove,
	setStatus: (id, status, reason) => http.put(`/${id}/status`, { status, reason }),
	/** Advisory pre-save check; create/update re-evaluate it server-side. */
	overlapCheck: (dto, id) => http.post('/overlap-check', { id: id || null, strategy: dto }),
	/** Launch a pass of every strategy on in one product now, outside
	 *  their run hours (CU-869fm5juc). Audited server-side as `force_run`
	 *  on each strategy on; the engine answers with what it created. The
	 *  per-strategy Run now is gone. */
	runProductNow: (productId, reason) => http.post(`/products/${productId}/run-now`, { reason: reason || null }),
	/**
	 * The engine's number of rate shops per day (criteria 27-29, UX D5):
	 * never a formula typed in the front. `get` answers for the tenant as
	 * it is (the table, the panel, Executions; cached 60 s by webback);
	 * `check` answers for a draft of the wizard without saving it —
	 * `{ strategy: <dto>, id }`, `id` null for a new one.
	 * Shape: `{ per_strategy: { <id|draft>: { searches_per_run, tasks_per_run,
	 * runs_per_day, searches_per_day, shared_per_day, breakdown, pickup_ranges,
	 * reason, skipped } }, per_product: { <id>: { run_now } }, grouped_total,
	 * plain_total, alignment_hints, warning }` — `per_product` is read only by
	 * `@services/runNow.js` (CU-869fm5juc).
	 * `zero_today` is always null since CU-869fkr1a9 (no pickup horizon).
	 */
	rateShops: {
		get:   () => http.get('/rate-shops'),
		check: (dto, id) => http.post('/rate-shops', { id: id || null, strategy: dto }),
	},
}
